module.exports = __webpack_public_path__ + "media/site/images/products/eplaning-screen2@2x-310515b45b1b728357da9dbb0b860adb.png";